import { getCollectionItem } from "common/contentCollection";
import { i as isOverdue, f as formatShortDate } from "common/chunk_time";
import { getAssetsUrl } from "common/helpers";
import { I18n } from "@devforce/trailhead-client-locale";

var data$9 = {
  dueDateLabel: "Fällig am: %{formattedDueDate}",
  overdueLabel: "Überfällig: %{formattedDueDate}",
  assignedByLabel: "Zugewiesen von %{assignedBy}",
  salesforceLogoAltText: "Salesforce-Logo",
  employeetrail_pretitle: "Privater Trail",
};
data$9.dueDateLabel;
data$9.overdueLabel;
data$9.assignedByLabel;
data$9.salesforceLogoAltText;
data$9.employeetrail_pretitle;

var data$8 = {
  dueDateLabel: "Due: %{formattedDueDate}",
  overdueLabel: "Past Due: %{formattedDueDate}",
  assignedByLabel: "Assigned by %{assignedBy}",
  salesforceLogoAltText: "Salesforce Logo",
  employeetrail_pretitle: "Private Trail",
};
data$8.dueDateLabel;
data$8.overdueLabel;
data$8.assignedByLabel;
data$8.salesforceLogoAltText;
data$8.employeetrail_pretitle;

var data$7 = {
  dueDateLabel: "Vence el %{formattedDueDate}",
  overdueLabel: "Caducado desde el %{formattedDueDate}",
  assignedByLabel: "Asignado por %{assignedBy}",
  salesforceLogoAltText: "Logotipo de Salesforce",
  employeetrail_pretitle: "Ruta privada",
};
data$7.dueDateLabel;
data$7.overdueLabel;
data$7.assignedByLabel;
data$7.salesforceLogoAltText;
data$7.employeetrail_pretitle;

var data$6 = {
  dueDateLabel: "Vence el: %{formattedDueDate}",
  overdueLabel: "Atrasado: %{formattedDueDate}",
  assignedByLabel: "Asignado por %{assignedBy}",
  salesforceLogoAltText: "Logotipo de Salesforce",
  employeetrail_pretitle: "Ruta privada",
};
data$6.dueDateLabel;
data$6.overdueLabel;
data$6.assignedByLabel;
data$6.salesforceLogoAltText;
data$6.employeetrail_pretitle;

var data$5 = {
  dueDateLabel: "Échéance : %{formattedDueDate}",
  overdueLabel: "En retard : %{formattedDueDate}",
  assignedByLabel: "Attribué par %{assignedBy}",
  salesforceLogoAltText: "Logo Salesforce",
  employeetrail_pretitle: "Parcours privé",
};
data$5.dueDateLabel;
data$5.overdueLabel;
data$5.assignedByLabel;
data$5.salesforceLogoAltText;
data$5.employeetrail_pretitle;

var data$4 = {
  dueDateLabel: "Scadenza: %{formattedDueDate}",
  overdueLabel: "Scaduti: %{formattedDueDate}",
  assignedByLabel: "Assegnato da %{assignedBy}",
  salesforceLogoAltText: "Logo di Salesforce",
  employeetrail_pretitle: "Itinerario privato",
};
data$4.dueDateLabel;
data$4.overdueLabel;
data$4.assignedByLabel;
data$4.salesforceLogoAltText;
data$4.employeetrail_pretitle;

var data$3 = {
  dueDateLabel: "期日: %{formattedDueDate}",
  overdueLabel: "期日経過: %{formattedDueDate}",
  assignedByLabel: "割り当て者が %{assignedBy}",
  salesforceLogoAltText: "Salesforce のロゴ",
  employeetrail_pretitle: "非公開トレイル",
};
data$3.dueDateLabel;
data$3.overdueLabel;
data$3.assignedByLabel;
data$3.salesforceLogoAltText;
data$3.employeetrail_pretitle;

var data$2 = {
  dueDateLabel: "기한: %{formattedDueDate}",
  overdueLabel: "만기 경과: %{formattedDueDate}",
  assignedByLabel: "할당한 사람: %{assignedBy}",
  salesforceLogoAltText: "Salesforce 로고",
  employeetrail_pretitle: "비공개 트레일",
};
data$2.dueDateLabel;
data$2.overdueLabel;
data$2.assignedByLabel;
data$2.salesforceLogoAltText;
data$2.employeetrail_pretitle;

var data$1 = {
  dueDateLabel: "Data de vencimento: %{formattedDueDate}",
  overdueLabel: "Vencido a: %{formattedDueDate}",
  assignedByLabel: "Atribuído por %{assignedBy}",
  salesforceLogoAltText: "Logotipo do Salesforce",
  employeetrail_pretitle: "Trilha privada",
};
data$1.dueDateLabel;
data$1.overdueLabel;
data$1.assignedByLabel;
data$1.salesforceLogoAltText;
data$1.employeetrail_pretitle;

var data = {
  dueDateLabel: "到期：%{formattedDueDate}",
  overdueLabel: "过期：%{formattedDueDate}",
  assignedByLabel: "由 %{assignedBy} 分配",
  salesforceLogoAltText: "Salesforce 徽标",
  employeetrail_pretitle: "专用学习路径",
};
data.dueDateLabel;
data.overdueLabel;
data.assignedByLabel;
data.salesforceLogoAltText;
data.employeetrail_pretitle;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

var salesforceLogo =
  "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cpath%20fill%3D%22%23E5E5E5%22%20d%3D%22M0%200h18v18H0z%22%2F%3E%3Cpath%20d%3D%22M-662-601a2%202%200%200%201%202-2h3116c1.1%200%202%20.895%202%202v3379c0%201.1-.9%202-2%202H-660c-1.104%200-2-.9-2-2V-601z%22%20fill%3D%22%23ADADAD%22%2F%3E%3Cpath%20d%3D%22M-660-602h3116v-2H-660v2zm3117%201v3379h2V-601h-2zm-1%203380H-660v2h3116v-2zm-3117-1V-601h-2v3379h2zm1%201c-.552%200-1-.45-1-1h-2c0%201.66%201.343%203%203%203v-2zm3117-1c0%20.55-.45%201-1%201v2c1.66%200%203-1.34%203-3h-2zm-1-3380c.55%200%201%20.448%201%201h2c0-1.657-1.34-3-3-3v2zm-3116-2a3%203%200%200%200-3%203h2a1%201%200%200%201%201-1v-2z%22%20fill%3D%22%23000%22%20fill-opacity%3D%22.1%22%2F%3E%3Cg%20clip-path%3D%22url%28%23a%29%22%3E%3Cpath%20fill%3D%22%23F3F3F3%22%20d%3D%22M-582-523H858v3223H-582z%22%2F%3E%3Cg%20filter%3D%22url%28%23b%29%22%3E%3Crect%20x%3D%22-20%22%20y%3D%22-227%22%20width%3D%22822%22%20height%3D%22328%22%20rx%3D%2212%22%20fill%3D%22%23fff%22%20shape-rendering%3D%22crispEdges%22%2F%3E%3Crect%20x%3D%22-19.5%22%20y%3D%22-226.5%22%20width%3D%22821%22%20height%3D%22327%22%20rx%3D%2211.5%22%20stroke%3D%22%23E5E5E5%22%20shape-rendering%3D%22crispEdges%22%2F%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20rx%3D%222%22%20fill%3D%22url%28%23c%29%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20fill%3D%22%23fff%22%20transform%3D%22translate%28-582%20-523%29%22%20d%3D%22M0%200h1440v3223H0z%22%2F%3E%3C%2FclipPath%3E%3Cpattern%20id%3D%22c%22%20patternContentUnits%3D%22objectBoundingBox%22%20width%3D%221%22%20height%3D%221%22%3E%3Cuse%20xlink%3Ahref%3D%22%23d%22%20transform%3D%22scale%28.01563%29%22%2F%3E%3C%2Fpattern%3E%3Cfilter%20id%3D%22b%22%20x%3D%22-24%22%20y%3D%22-230%22%20width%3D%22830%22%20height%3D%22336%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%20result%3D%22hardAlpha%22%2F%3E%3CfeMorphology%20radius%3D%221%22%20operator%3D%22dilate%22%20in%3D%22SourceAlpha%22%20result%3D%22effect1_dropShadow_3_2%22%2F%3E%3CfeOffset%20dy%3D%221%22%2F%3E%3CfeGaussianBlur%20stdDeviation%3D%221.5%22%2F%3E%3CfeComposite%20in2%3D%22hardAlpha%22%20operator%3D%22out%22%2F%3E%3CfeColorMatrix%20values%3D%220%200%200%200%200.0941176%200%200%200%200%200.0941176%200%200%200%200%200.0941176%200%200%200%200.06%200%22%2F%3E%3CfeBlend%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow_3_2%22%2F%3E%3CfeBlend%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow_3_2%22%20result%3D%22shape%22%2F%3E%3C%2Ffilter%3E%3Cimage%20id%3D%22d%22%20width%3D%2264%22%20height%3D%2264%22%20preserveAspectRatio%3D%22none%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw%2FeHBhY2tldCBiZWdpbj0i77u%2FIiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8%2BIDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMC1jMDAwIDc5LjE3MWMyN2ZhYiwgMjAyMi8wOC8xNi0yMjozNTo0MSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODhDNDc5N0E0ODA0MTFFREJGODRFMzE0NzlCM0ZEQkYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODhDNDc5Nzk0ODA0MTFFREJGODRFMzE0NzlCM0ZEQkYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIzLjUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQzNEMjlGOTM5MkQxMUVEODRBM0I0QkJGNjM2MEQ0OCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQzNEMjlGQTM5MkQxMUVEODRBM0I0QkJGNjM2MEQ0OCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI%2FPkdGzEcAAAKZSURBVHja7FuNdYIwEA7UARjBTlCcQJygOoEwQesE6gQ%2BJ5BMIJ1AnEA2MBuUDWxCQh%2F4QP4iIJd7L7XvSVLuu9x3d8lVu91uCLLoCLgoABQACgAFgAJAAQBYtEpPY2LQnzYdn3RYGU8EdPjsSbQcB8MBgCv%2BTce6wtoMCIcCQR6syUA06ZgmvjnTweZ4dG7YPQCYsBc80jGusT5TYEUVcTPA%2FKLDKJjvivlhNwBw5U8lXrRInAgETOb090PF9UIx32sXAEyYxS8SlE9a024MYotR4ChRedRQeRTtHEzsdnYA%2F0OHHpI2c4eJIM%2BpIFAzg3yDiExLuE0eANeapNc3YdFk%2B8h1tBziuwws38kNyVkcMB9gwmdFRuXGLQRgOtCs14hC%2Bh0I0GoBI4puPBkDWwwxct9BrwZtkeiBLofXeQCcAe0CIwsAD9AusPQcpoQi5ltGDXAEBECov0AB9NS8QBfKWwCVT%2BUBO6ixUBfHVCZQ%2Fc9sB3wCToaIPtDyt6x4OrC4n074luMQci2wh1wM%2BdT6PlQA%2BEVLIg8IgAGwQPy0%2BB8AH5Dyzr2%2BmjgZuQ493keWz7iy18VZuTtgf98idpuU068wEp8rxM%2FOx4OJ8fxkyy26WtcS5bCsq%2FA2rfsu3jc2XFC1lyB9NcZBOLxIcTSR0YaTzgP4gjPhN2GPLe%2FI6kF61CBhiELpI2NHWJ1lcLxlRlruotWahcmvZK4IBRHH3WfG3XeM1HCcvsqUUc15KyT3CG0v7vBbD8da7ZmYnCS5AmPuSVeE0qQYWkioI2LSRa8HAI%2B3swa1BFe%2BhWbI57hA2h02qFzjY0xqzOc3fYipmrSVivuI2U75KZOetgqA%2Bq8x4KIAUAAoABQACgAFgAIArvwJMAAOa7CDYqjyiAAAAABJRU5ErkJggg%3D%3D%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

const i18n = new I18n({
  assignments: locales,
});
function generateDueDateHtml(assignment) {
  if (!assignment) return "";
  const isAssignmentOverdue = assignment.dueDate
    ? !assignment.completed && isOverdue(assignment.dueDate)
    : false;
  const formattedDueDate =
    (assignment.dueDate && formatShortDate(assignment.dueDate)) || "";
  const dueDateLabel = isAssignmentOverdue
    ? i18n.t("assignments", "overdueLabel", {
        formattedDueDate,
      })
    : i18n.t("assignments", "dueDateLabel", {
        formattedDueDate,
      });
  return `
    <div class="due-date">
      <tds-badge${
        isAssignmentOverdue ? " variant='badge-error'" : ""
      }>${dueDateLabel}</tds-badge>
    </div>
  `;
}
function stripEstimatedTimeLeft(contentSummary) {
  if (!contentSummary) return null;
  const { user, ...rest } = contentSummary;
  return {
    ...rest,
    user: {
      ...user,
      estimatedTimeLeft: null,
    },
  };
}
function formatDueDateLabel(assignment) {
  if (!assignment) return "";
  return assignment.dueDate ? formatShortDate(assignment.dueDate) : "";
}
function generateAssignedByHtml(assignment) {
  if (!assignment) return "";
  const assignedByLabel = i18n.t("assignments", "assignedByLabel", {
    assignedBy: assignment.assignedBy,
  });
  return `
    <div class="assigned-by" style="display: flex; align-items: center; gap: var(--tds-spacing-2);">
      <img class="logo" alt="${i18n.t(
        "assignments",
        "salesforceLogoAltText"
      )}" src="${getAssetsUrl(salesforceLogo)}" />
      <span>${assignedByLabel}</span>
    </div>
  `;
}

/**
 * Normalizes user percentage complete - converts 0.0 to undefined to avoid showing 0% progress on trails that have not been started
 */
function normalizeUserPercentageComplete(user) {
  if (!user) return user;
  return user.percentageComplete === 0.0 &&
    (user.state === "NOT_STARTED" || !user.state)
    ? {
        ...user,
        percentageComplete: undefined,
      }
    : user;
}

/**
 * Appends a collection item with assignment-specific data (HTML content and assignment object)
 */
function appendAssignmentMetadata(item, assignment) {
  return {
    ...item,
    summary: {
      ...item.summary,
      user: normalizeUserPercentageComplete(item.summary.user),
      actionHtml: generateDueDateHtml(assignment),
      metaLeftHtml: generateAssignedByHtml(assignment),
      pretitle: i18n.t("assignments", "employeetrail_pretitle"),
      assignment,
    },
  };
}
function getAssignmentCollectionItems(result) {
  const edges = result.data.assignedLearnings.edges || [];
  return edges
    .map((edge) => edge?.node)
    .filter((node) => node != null)
    .map((assignedLearning, index) => {
      const collectionItem = getCollectionItem(assignedLearning.summary);
      const assignmentItem = appendAssignmentMetadata(
        collectionItem,
        assignedLearning.assignment
      );

      // Create a unique key by combining summary ID with index to prevent duplicate keys
      const uniqueKey = `${assignedLearning.summary.id}:${index}`;
      return {
        ...assignmentItem,
        summary: {
          ...assignmentItem.summary,
          id: uniqueKey, // Override the ID to be unique
        },
      };
    });
}

export {
  appendAssignmentMetadata,
  formatDueDateLabel,
  generateAssignedByHtml,
  generateDueDateHtml,
  getAssignmentCollectionItems,
  normalizeUserPercentageComplete,
  stripEstimatedTimeLeft,
};
